<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <b-form-row class="mb-3 align-items-end">
          <b-col md="2">
            <label>{{$t('STARTDATE')}}</label>
            <datepicker v-model="startDate" />
          </b-col>
          <b-col md="2">
            <label>{{$t('ENDDATE')}}</label>
            <datepicker v-model="endDate" />
          </b-col>
          <b-col md="2">
            <button type="button" class="btn btn-primary" @click="getData">
              {{$t('REFRESH')}}
            </button>
          </b-col>
        </b-form-row>

        <loading v-if="isLoading" />

        <template v-if="!isLoading && analysisData">
          <!-- Summary card -->
          <div class="card mb-4">
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4" v-if="analysisData.summary">
                  <div class="h4">{{analysisData.summary.totalCount}}</div>
                  <div class="text-muted">{{$t('TOTAL_INVOICES')}}</div>
                </div>
                <div class="col-md-4" v-if="analysisData.summary">
                  <div class="h4">{{formatAmount(analysisData.summary.totalAmount)}}</div>
                  <div class="text-muted">{{$t('TOTAL_AMOUNT')}}</div>
                </div>
                <div class="col-md-4" v-if="analysisData.summary">
                  <div class="h4">{{formatAmount(analysisData.summary.averageAmount)}}</div>
                  <div class="text-muted">{{$t('AVERAGE_AMOUNT')}}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Breakdown tables -->
          <div class="row">
            <div class="col-md-6 mb-4">
              <div class="card">
                <div class="card-header">{{$t('BY_PAYMENT_TYPE')}}</div>
                <div class="card-body p-0">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>{{$t('PAYMENTTYPE')}}</th>
                        <th>{{$t('COUNT')}}</th>
                        <th>{{$t('TOTAL_AMOUNT')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in analysisData.byPaymentType" :key="row.paymentType">
                        <td>{{row.paymentType}}</td>
                        <td>{{row.count}}</td>
                        <td>{{formatAmount(row.totalAmount)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <div class="card">
                <div class="card-header">{{$t('BY_THERAPY_TYPE')}}</div>
                <div class="card-body p-0">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>{{$t('THERAPYTYPE')}}</th>
                        <th>{{$t('COUNT')}}</th>
                        <th>{{$t('TOTAL_AMOUNT')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in analysisData.byTherapyType" :key="row.therapyType">
                        <td>{{row.therapyType}}</td>
                        <td>{{row.count}}</td>
                        <td>{{formatAmount(row.totalAmount)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <div class="card">
                <div class="card-header">{{$t('BY_USER')}}</div>
                <div class="card-body p-0">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>{{$t('CREATEDBYUSER')}}</th>
                        <th>{{$t('COUNT')}}</th>
                        <th>{{$t('TOTAL_AMOUNT')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in analysisData.byUser" :key="row.createdByUser">
                        <td>{{row.createdByUser}}</td>
                        <td>{{row.count}}</td>
                        <td>{{formatAmount(row.totalAmount)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <div class="card">
                <div class="card-header">{{$t('BY_MONTH')}}</div>
                <div class="card-body p-0">
                  <table class="table table-sm table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>{{$t('MONTH')}}</th>
                        <th>{{$t('COUNT')}}</th>
                        <th>{{$t('TOTAL_AMOUNT')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in analysisData.byMonth" :key="row.month">
                        <td>{{row.month}}</td>
                        <td>{{row.count}}</td>
                        <td>{{formatAmount(row.totalAmount)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api/fakturko_invoices/FakturkoInvoices';

export default
{
    name: 'FakturkoAnalysisWin',
    data()
    {
        return {
            startDate: null,
            endDate: null,
            analysisData: null,
            isLoading: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
    {
        async getData()
        {
            const me = this;
            me.isLoading = true;
            try
            {
                const params = {
                    startDate: me.startDate,
                    endDate: me.endDate,
                };
                const data = await Api.financialAnalysis(params);
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.analysisData = data.root;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
            finally
            {
                me.isLoading = false;
            }
        },
        formatAmount(value)
        {
            return parseFloat(value || 0).toFixed(2);
        },
    },
};
</script>
